import { render, staticRenderFns } from "./UpdateRoofStructure.vue?vue&type=template&id=62812839"
import script from "./UpdateRoofStructure.vue?vue&type=script&lang=ts"
export * from "./UpdateRoofStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports